import {AfterViewInit, Component} from '@angular/core';
import {GlobalDataService, ResetAuthToken} from './global-data.service';
import {Router} from '@angular/router';

declare var jQuery: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements AfterViewInit {
  service = this.globalDataService;

  constructor(private globalDataService: GlobalDataService, private router: Router) {
  }

  ngAfterViewInit() {
    // jQuery('.menu-link').click(function() {
    //   jQuery('.navbar-collapse').collapse('hide');
    // });
  }

  logout() {
    ResetAuthToken.call(this);
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts